<script>
import { Doughnut, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    data: {
      type: Object
    },
    titulo: {
      type: String
    }
  },

  data() {
    return {
      options: {
        title: {
          display: true,
          text: this.titulo
        },
        responsive: true,
        scales: {
          yAxes: [
            {
              display: true
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true
        },
        xaxis: {
          categories: this.data
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "0.85rem"
            }
          }
        },

        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              var dataset = data.datasets[tooltipItem.datasetIndex];
              var total = dataset.data.reduce(function(
                previousValue,
                currentValue,
                currentIndex,
                array
              ) {
                return previousValue + currentValue;
              });
              var currentValue = dataset.data[tooltipItem.index];
              var percentage = Math.floor((currentValue / total) * 100 + 0.5);
              return currentValue + " (" + percentage + "%)";
            }
          }
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {}
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/charts/Pie.vue